import React from 'react';
import PropTypes from 'prop-types';
import { zip, flatten } from 'lodash';
import { flow, filter } from 'lodash/fp';

import { View } from '@dbk/ui-react-utils';
import { IconButton } from '@dbk/ui-buttons'
import Text from '@dbk/ui-text';

import ListView from '../../icons/list-view';
import ChartView from '../../icons/chart-view';
import { testIDProps } from '../../utils/with-automation-id-props';

const Icons = {
  '0': ChartView,
  '1': ListView,
};

const PortfolioHeaderSwitch = (props) => {
  const {
    options,
    selectedView,
    onSwitch,
    iconFill,
    activeIconFill,
    containerProps,
    iconsProps,
    messages
  } = props;

  const renderSwitchIcons = options => options.map((option, index) => {
    const isActive = option.value === selectedView;
    const fillColor = isActive ? activeIconFill : iconFill;
    const Icon = Icons[index];

    const onIconSwitch = (index) => () => onSwitch(index);

    return (
      <IconButton onPress={onIconSwitch(index)} {...testIDProps(`btn_portfolio_switchCommon_${index}_test`)} accessibilityLabel={index? messages['app.accessibility.assets.icon.listview']:messages['app.accessibility.assets.icon.chartview']}>
        <Icon fill={fillColor}/>
      </IconButton>
    );
  });

  const renderSeparator = () => (
    <View className='portfolio-header__separator'>
      <Text style={{ color: '#A7A8AA' }}> | </Text>
    </View>
  );

  const isElement = elem => elem;
  const createIcons = options => flatten(zip(renderSwitchIcons(options), [renderSeparator()]));

  const SwitchIcons = flow(createIcons, filter(isElement))(options);

  return (
    <View {...containerProps}>
      <View {...iconsProps}>
        {SwitchIcons}
      </View>
    </View>
  );
};


PortfolioHeaderSwitch.propTypes = {
  options: PropTypes.array.isRequired,
  onSwitch: PropTypes.func.isRequired,
  selectedView: PropTypes.string.isRequired,
  activeIconFill: PropTypes.string,
  iconFill: PropTypes.string,
};

export default PortfolioHeaderSwitch;
